import { useState, useEffect, useRef, useMemo } from "react";
import NavBar from "../components/NavBar/NavBar";
import FirstSection from "../components/Partner/FirstSection";
import SecondSection from "../components/Partner/SecondSection";
import EmpathyProcessSection from "../components/Partner/EmpathyProcessSection";
import FinalSection from "../components/Partner/FinalSection";
import { useTranslation } from "react-i18next";

export default function CreativePartnerLandingPage() {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [isFloating, setIsFloating] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const finalSectionRef = useRef(null);

  const pipelineSteps = useMemo(() => [
    { title: t("partner.partnersPipeline"), icon: "Zap" },
    { title: t("partner.empathyInfusion"), icon: "Sparkles" },
    { title: t("partner.growthAcceleration"), icon: "Rocket" },
    { title: t("partner.marketBloom"), icon: "Users" },
  ], [t]);

  useEffect(() => {
    const floatInterval = setInterval(() => {
      setIsFloating((prev) => !prev);
    }, 2000);
    return () => clearInterval(floatInterval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (isVisible) {
      interval = setInterval(() => {
        setCurrentStep((prev) => (prev + 1) % pipelineSteps.length);
      }, 2000);
    } else {
      setCurrentStep(0);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isVisible, pipelineSteps.length]);

  return (
    <>
      <NavBar />
      <div className="flex flex-col min-h-screen bg-grey-100 ">
        <main className="flex-1">
          <FirstSection finalSectionRef={finalSectionRef} />
          <SecondSection />
          <EmpathyProcessSection
            pipelineSteps={pipelineSteps}
            currentStep={currentStep}
            sectionRef={sectionRef}
          />
          <FinalSection ref={finalSectionRef} />
        </main>
      </div>
    </>
  );
}
